/* ISEO product page: gallery with video, variant picker, quantity. No dependencies. */
(function () {
  if (window.iseoBooted) return;
  window.iseoBooted = true;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var slides = root.querySelectorAll('[data-iseo-slide]');
    var thumbs = root.querySelectorAll('[data-iseo-thumb]');
    var stage = root.querySelector('.iseo-gallery__stage');
    var inView = false;

    function activeVideo() {
      var slide = root.querySelector('[data-iseo-slide].is-active');
      return slide ? slide.querySelector('video') : null;
    }

    // Play only the visible video, only while the stage is on screen, never with reduced motion
    function syncVideo() {
      root.querySelectorAll('video').forEach(function (v) {
        var shouldPlay = !reduceMotion && inView && v === activeVideo();
        if (shouldPlay) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }

    function show(mediaId) {
      var found = false;
      slides.forEach(function (s) {
        var on = s.dataset.mediaId === String(mediaId);
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) found = true;
      });
      if (!found) return;
      thumbs.forEach(function (t) {
        t.setAttribute('aria-current', t.dataset.mediaId === String(mediaId) ? 'true' : 'false');
      });
      syncVideo();
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(t.dataset.mediaId); });
    });

    // Reduced motion: show native controls so the shopper can still play the video
    if (reduceMotion) {
      root.querySelectorAll('video').forEach(function (v) { v.setAttribute('controls', ''); });
    }

    if ('IntersectionObserver' in window && stage) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        syncVideo();
      }, { threshold: 0.5 }).observe(stage);
    }

    root.iseoShow = show;
  }

  /* ---------- Product form ---------- */
  function initForm(form) {
    var section = form.closest('[data-iseo-product]');
    var dataEl = section && section.querySelector('[data-iseo-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var idInput = form.querySelector('[name="id"]');
    var addBtn = form.querySelector('[data-iseo-add]');
    var priceNow = section.querySelector('[data-iseo-price]');
    var priceWas = section.querySelector('[data-iseo-compare]');
    var gallery = section.querySelector('[data-iseo-gallery]');

    function selected() {
      var out = [];
      form.querySelectorAll('[data-iseo-option]').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        out[parseInt(fs.dataset.iseoOption, 10)] = checked ? checked.value : null;
      });
      return out;
    }

    function update() {
      var sel = selected();
      var v = variants.find(function (x) {
        return x.options.every(function (o, i) { return sel[i] == null || sel[i] === o; });
      });
      if (!v) {
        addBtn.disabled = true;
        addBtn.textContent = addBtn.dataset.unavailable;
        return;
      }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? addBtn.dataset.add : addBtn.dataset.soldOut;
      if (priceNow) priceNow.textContent = v.price;
      if (priceWas) {
        priceWas.textContent = v.compare || '';
        priceWas.hidden = !v.compare;
      }
      if (v.media && gallery && gallery.iseoShow) gallery.iseoShow(v.media);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    form.querySelectorAll('[data-iseo-option] input').forEach(function (i) {
      i.addEventListener('change', update);
    });

    // Size scale follows the chosen size variant
    form.querySelectorAll('input[data-size-key]').forEach(function (i) {
      i.addEventListener('change', function () {
        form.querySelectorAll('[data-iseo-scale] [data-key]').forEach(function (item) {
          item.classList.toggle('is-current', item.dataset.key === i.dataset.sizeKey);
        });
      });
    });

    // Quantity stepper
    var qty = form.querySelector('[data-iseo-qty]');
    if (qty) {
      form.querySelectorAll('[data-iseo-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.iseoStep, 10));
          qty.value = n;
        });
      });
    }
  }

  /* ---------- Autoplay videos (cards, watch pill) while on screen ---------- */
  function initAutoplay() {
    if (reduceMotion || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.6 });
    document.querySelectorAll("[data-iseo-autoplay]").forEach(function (v) {
      v.addEventListener("playing", function () { v.classList.add("is-playing"); });
      io.observe(v);
    });
  }

  /* ---------- "Watch it spin" pill jumps to the gallery video ---------- */
  function initWatch() {
    document.querySelectorAll("[data-iseo-watch]").forEach(function (btn) {
      var gallery = btn.closest("[data-iseo-gallery]");
      btn.addEventListener("click", function () {
        if (gallery && gallery.iseoShow) gallery.iseoShow(btn.dataset.mediaId);
        btn.hidden = true;
      });
      if (gallery) {
        gallery.querySelectorAll("[data-iseo-thumb]").forEach(function (t) {
          t.addEventListener("click", function () { btn.hidden = t.dataset.mediaId === btn.dataset.mediaId; });
        });
      }
    });
  }

  /* ---------- Hero reel: one spinning clip at a time, crossfade every 6s ---------- */
  function initReel(reel) {
    var clips = Array.prototype.slice.call(reel.querySelectorAll("[data-iseo-clip]"));
    if (!clips.length || reduceMotion) return;
    var i = 0, timer = null, inView = true;
    function video(n) { return clips[n].querySelector("video"); }
    function play(n) { var p = video(n).play(); if (p && p.catch) p.catch(function () {}); }
    function next() {
      var cur = i;
      i = (i + 1) % clips.length;
      var nv = video(i);
      if (nv.preload === "none") nv.preload = "auto";
      play(i);
      clips[i].classList.add("is-active");
      clips[cur].classList.remove("is-active");
      setTimeout(function () { if (cur !== i) video(cur).pause(); }, 900);
      var after = video((i + 1) % clips.length);
      if (after.preload === "none") after.preload = "auto";
    }
    function start() { if (!timer && clips.length > 1) timer = setInterval(next, 6000); play(i); }
    function stop() { clearInterval(timer); timer = null; video(i).pause(); }
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (e) { inView = e[0].isIntersecting; if (inView) { start(); } else { stop(); } }, { threshold: 0.3 }).observe(reel);
    } else {
      start();
    }
    document.addEventListener("visibilitychange", function () { if (document.hidden) { stop(); } else if (inView) { start(); } });
  }

  /* ---------- Blog: inline product box placed before the Nth subheading ---------- */
  function initInline(tpl) {
    var article = document.querySelector(".article-content");
    if (!article) return;
    var n = parseInt(tpl.dataset.after, 10) || 3;
    var heads = article.querySelectorAll("h2");
    var box = tpl.content.firstElementChild.cloneNode(true);
    var target = heads[n - 1] || heads[heads.length - 1];
    if (target) {
      target.parentNode.insertBefore(box, target);
    } else {
      var paras = article.querySelectorAll("p");
      var p = paras[Math.min(2, paras.length - 1)];
      if (p) p.parentNode.insertBefore(box, p.nextSibling);
    }
  }

  /* ---------- Collection: filter cards by design and size ---------- */
  function initFilter(bar) {
    var section = bar.closest('.iseo-wrap');
    var items = section.querySelectorAll('.iseo-grid > li');
    var count = bar.querySelector('[data-filter-count]');
    var empty = section.querySelector('[data-filter-empty]');
    var state = { series: '', size: '' };

    function apply() {
      var shown = 0;
      items.forEach(function (li) {
        var okSeries = !state.series || li.dataset.series === state.series;
        var okSize = !state.size || (' ' + li.dataset.sizes + ' ').indexOf(' ' + state.size + ' ') > -1;
        var on = okSeries && okSize;
        li.hidden = !on;
        if (on) shown++;
      });
      bar.querySelectorAll('[data-filter-series]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.dataset.filterSeries === state.series ? 'true' : 'false');
      });
      bar.querySelectorAll('[data-filter-size]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.dataset.filterSize === state.size ? 'true' : 'false');
      });
      var filtered = state.series || state.size;
      if (count) count.textContent = filtered ? shown + (shown === 1 ? ' spinner' : ' spinners') : '';
      if (empty) empty.hidden = shown > 0;
    }

    bar.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      if ('filterSeries' in b.dataset) state.series = b.dataset.filterSeries;
      if ('filterSize' in b.dataset) state.size = b.dataset.filterSize;
      apply();
    });
    var reset = section.querySelector('[data-filter-reset]');
    if (reset) reset.addEventListener('click', function () { state.series = ''; state.size = ''; apply(); });
  }

  function boot() {
    document.querySelectorAll('[data-iseo-filter]').forEach(initFilter);
    document.querySelectorAll("template[data-iseo-inline]").forEach(initInline);
    document.querySelectorAll("[data-iseo-reel]").forEach(initReel);
    initAutoplay();
    initWatch();
    document.querySelectorAll('[data-iseo-gallery]').forEach(initGallery);
    document.querySelectorAll('form.iseo-form').forEach(initForm);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
